module.exports = __webpack_public_path__ + "media/images/countryrect/cz-54ec61a525901ef7c0183cedcb4e8d34.svg";